// Search-friendly titles, descriptions and the everyday words people type into Google / AI assistants
export const SERVICE_SEO = {
  "hypertension-management": {
    title: "Hypertension & High Blood Pressure (BP) Specialist in Cambridge",
    description: "Consultant physicians in Cambridge for high blood pressure (hypertension, high BP) - diagnosis, hard-to-control BP, young-onset and secondary causes. Self-pay, self-referral welcome.",
    aka: ["High blood pressure clinic", "High BP doctor", "Hypertension clinic Cambridge", "Blood pressure specialist"],
  },
  "lipid-management": {
    title: "Cholesterol & Lipid Clinic in Cambridge",
    description: "Consultant-led cholesterol and lipid assessment in Cambridge, including familial hypercholesterolaemia and heart-attack and stroke prevention.",
    aka: ["High cholesterol doctor", "Lipid clinic Cambridge", "Preventive cardiology"],
  },
  "ambulatory-bp-monitoring": {
    title: "24-Hour Blood Pressure Monitoring (ABPM) in Cambridge",
    description: "24-hour ambulatory blood pressure (BP) monitoring in Cambridge, interpreted by a hypertension specialist - a truer picture than a single clinic reading.",
    aka: ["24 hour BP monitor", "ABPM Cambridge", "Ambulatory blood pressure test"],
  },
  "holter-monitoring": {
    title: "ECG & Holter Heart Rhythm Monitoring in Cambridge - Palpitations & Dizziness",
    description: "ECG and Holter heart-rhythm monitoring in Cambridge to investigate palpitations, dizziness, dizzy spells, fainting and irregular heartbeat. Consultant-led.",
    aka: ["ECG Cambridge", "Holter monitor", "Heart rhythm test", "Palpitations test", "Ambulatory ECG"],
  },
  echocardiography: {
    title: "Echocardiogram (Echo) Heart Scan in Cambridge",
    description: "EACVI-accredited echocardiogram (echo heart scan / heart ultrasound) in Cambridge - checks heart structure and function, e.g. for breathlessness, murmurs or high blood pressure.",
    aka: ["Echo Cambridge", "Heart scan Cambridge", "Heart ultrasound", "Echocardiography"],
  },
  bioimpedance: {
    title: "Body Composition Test (Bioimpedance) in Cambridge",
    description: "Bioimpedance body composition in Cambridge - measures body fat, muscle and body water to guide weight loss, blood pressure and metabolic health.",
    aka: ["Body fat test", "Body composition analysis", "Wellness check"],
  },
  "cardiovascular-risk-assessment": {
    title: "Heart Health Check & Cardiovascular Risk Assessment in Cambridge",
    description: "A consultant-led heart health check in Cambridge - your personal risk of heart attack and stroke, with a clear prevention plan. A wellness assessment for your heart.",
    aka: ["Heart health check", "Heart check Cambridge", "Wellness assessment", "Cardiac risk assessment"],
  },
  "cardiometabolic-prevention": {
    title: "Diabetes, Weight & Metabolic Health Clinic in Cambridge",
    description: "Consultant physicians in Cambridge assessing diabetes, pre-diabetes, weight, blood pressure and metabolic health together - internal medicine with a prevention focus.",
    aka: ["Diabetes clinic Cambridge", "Metabolic health", "Pre-diabetes", "Internal medicine Cambridge"],
  },
  "carotid-imt": {
    title: "Carotid Artery Scan (cIMT) in Cambridge",
    description: "Carotid intima-media thickness (cIMT) ultrasound in Cambridge - a painless neck artery scan for early signs of cardiovascular risk.",
    aka: ["Carotid scan", "Artery scan", "Vascular ultrasound"],
  },
  "arterial-stiffness": {
    title: "Arterial Stiffness Test in Cambridge",
    description: "Arterial stiffness (pulse wave velocity) testing in Cambridge - a non-invasive measure of vascular age and long-term cardiovascular risk.",
    aka: ["Pulse wave velocity", "Vascular age test"],
  },
  "flow-mediated-dilatation": {
    title: "Flow-Mediated Dilatation (FMD) Test in Cambridge",
    description: "Flow-mediated dilatation (FMD) in Cambridge - a specialised vascular ultrasound of how well your artery lining works.",
    aka: ["Endothelial function test", "FMD test"],
  },
  "supported-weight-loss": {
    title: "Medical Weight Loss Programme in Cambridge",
    description: "Consultant-led medical weight loss in Cambridge for people whose weight affects blood pressure, cholesterol, diabetes risk or heart health. Structured and monitored.",
    aka: ["Weight loss clinic Cambridge", "Medical weight management", "Weight loss doctor"],
  },
};

// Common symptoms people search for, and where on the site they are covered
export const SYMPTOMS = [
  { name: "Palpitations", text: "A racing, pounding, fluttering or irregular heartbeat.", to: "/services/holter-monitoring" },
  { name: "Dizziness or dizzy spells", text: "Light-headedness, feeling faint or blacking out.", to: "/services/holter-monitoring" },
  { name: "Shortness of breath", text: "Getting breathless more easily than you used to.", to: "/services/echocardiography" },
  { name: "Chest pain or tightness", text: "Chest discomfort that comes and goes, e.g. on exertion.", to: "/services/cardiovascular-risk-assessment" },
  { name: "Tiredness", text: "Ongoing fatigue that may be linked to blood pressure, heart or metabolic health.", to: "/services/cardiometabolic-prevention" },
  { name: "High blood pressure readings", text: "Raised BP at home, the GP or the pharmacy.", to: "/services/hypertension-management" },
];
